import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=f2f60184&scoped=true&"
import script from "./CreateEdit.vue?vue&type=script&lang=ts&"
export * from "./CreateEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=f2f60184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f60184",
  null
  
)

export default component.exports